import ShuwaWallet from "../../components/business/ShuwaWallet";

/** The business's SHUWA wallet: money customers paid online, withdrawn to mobile money. */
export default function Wallet() {
  return (
    <div>
      <h1 className="mb-6 font-montserrat text-2xl font-bold text-slate-900">Wallet</h1>
      <ShuwaWallet />
    </div>
  );
}
